export class InitialCallState {
  error = null;
  loading = false;
  loaded = false;
}
